(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('shopify-section-{{ section.id }}');
    if (!root) return;

    const mq = window.matchMedia('(max-width: 749px)');

    const forceCaptionVisible = () => {
      if (!mq.matches) return;

      const slides = root.querySelectorAll('slideshow-slide');
      slides.forEach((slide) => {
        // Any real caption text will include at least one of these
        const textNodes = slide.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,a,button');

        textNodes.forEach((el) => {
          // Force readable on iPhone + override theme hiding
          el.style.setProperty('opacity', '1', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('color', '#111', 'important');
          el.style.setProperty('-webkit-text-fill-color', '#111', 'important');
          el.style.setProperty('mix-blend-mode', 'normal', 'important');
        });

        // Walk up a few parents and undo "hidden"/display:none/opacity:0 on wrappers
        textNodes.forEach((el) => {
          let node = el;
          let steps = 0;

          while (node && node !== slide && steps < 7) {
            if (node.hasAttribute && node.hasAttribute('hidden')) node.removeAttribute('hidden');

            try {
              const cs = window.getComputedStyle(node);
              if (cs.display === 'none') node.style.setProperty('display', 'block', 'important');
              if (cs.opacity === '0') node.style.setProperty('opacity', '1', 'important');
              if (cs.visibility === 'hidden') node.style.setProperty('visibility', 'visible', 'important');
            } catch (e) {}

            node = node.parentElement;
            steps += 1;
          }
        });
      });
    };

    // Run now
    forceCaptionVisible();

    // Re-run when slider changes things (Atelier often toggles hidden/opacity on interaction)
    const mo = new MutationObserver(() => forceCaptionVisible());
    mo.observe(root, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });

    // Re-run when switching to/from mobile
    if (mq.addEventListener) mq.addEventListener('change', forceCaptionVisible);
    else mq.addListener(forceCaptionVisible);
  })();

  } catch(e) { console.error(e); }
})();
})();
